import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const ModalBody = styled.div`
  padding: 2em 3em 1em 3em;

  ${mediaMaxWidth.phone} {
    padding: 1em;
  }
`;

export const Column = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  ${mediaMaxWidth.phone} {
    width: 155px;
    margin: 0 auto;
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  /* margin-bottom: 2rem; */
`;

interface UsernameInputProps {
  error?: boolean;
}

export const UsernameInput = styled.input`
  flex: 1;
  border: 2px solid
    ${(props: UsernameInputProps) => (props.error ? "#79D9D9" : "#e7e7e7")};

  border-radius: 4px;
  resize: none;
  padding: 0.625rem;
  position: relative;
  min-width: 0;

  &:focus {
    border-color: #79D9D9;
    outline: none;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
  }
`;

export const DomainSelect = styled.select`
  flex: 0 1 auto;
  background-color: #fff;
  border: 2px solid #e7e7e7;
  padding: 0.625rem;
  margin: 0 3rem 0 1rem;
  border-radius: 4px;

  &:focus {
    border-color: #79D9D9;
    outline: none;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
  }
`;

export const DomainSpan = styled.span`
  display: flex;
  align-items: center;
  flex: 0 1 auto;
  margin: 0 3rem 0 1rem;
`;

export const AddButton = styled.button`
  flex: 0 1 auto;
`;

interface EmailAddressListProps {
  noMarginTop?: boolean;
}
export const EmailAddressList = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  margin-top: ${(props: EmailAddressListProps) =>
    props.noMarginTop ? "0" : "2rem"};
`;

export const EmailAddressListItem = styled.li`
  display: flex;
  flex-direction: column;
`;

export const EmailAddressValue = styled.span`
  margin-right: 0.5rem;
`;

export const EmailValueButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const CenterButtonWrapper = styled.span`
  display: flex;
  margin-top: 2rem;
  justify-content: center;
`;

export const EmailError = styled.span`
  color: red;
  font-size: 0.8rem;
  margin-bottom: 1rem;
`;

export const ErrorList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const ErrorListItem = styled.li`
  color: red;
`;

export const InvalidUsernameError = styled.span`
  color: red;
  margin-top: 0.5rem;
  display: inline-block;
`;
